import { render, staticRenderFns } from "./BlogForm.vue?vue&type=template&id=2106a22c&"
import script from "./BlogForm.ts?vue&type=script&lang=js&"
export * from "./BlogForm.ts?vue&type=script&lang=js&"
import style0 from "./BlogForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports